import { useNavigate } from 'react-router-dom'
import { Button } from '../../../components/button'
import { SelectProductModal } from '../../../components/modal/app_modals/selectProductModal'
import { ProductTileContainer } from '../../../components/product/productTile'
import { removeElementAtIndex } from '../../../helpers'
import { useModalControl } from '../../../hooks/useModalControl'
import { useEditSubCategoryMutation } from '../../../redux-toolkits/products/products.slice'
import { SingleSubCategoryResponse } from '../../../redux-toolkits/products/products.type'
import { Product } from '../../../redux-toolkits/products/products.type'
export const SubCategoryCuratedProducts = ({
  productPicks,
  singleSubCategoryDetails,
  subCategoryId,
  refetchSubCategoryDetails,
  setProductPicks,
  fetchingSingleSubCategoryDetails,
}: {
  productPicks: Product[]
  singleSubCategoryDetails?: SingleSubCategoryResponse
  subCategoryId: string
  refetchSubCategoryDetails: () => void
  setProductPicks: (picks: Product[]) => void
  fetchingSingleSubCategoryDetails: boolean
}) => {
  const navigate = useNavigate()

  const { modal, modalOpen, setModalOpen, handleModalOpen, handleModalClose } =
    useModalControl()

  const [editSubCategory, { isLoading: editingSubCategory }] =
    useEditSubCategoryMutation()

  return (
    <>
      <div className="flex items-center justify-end">
        <Button
          type="button"
          onClick={async () => {
            if (
              JSON.stringify(productPicks) !==
              JSON.stringify(singleSubCategoryDetails?.data?.ourPicks ?? [])
            ) {
              const resp = await editSubCategory({
                id: subCategoryId,
                payload: {
                  ourPicks: productPicks.map((picks) => picks._id),
                },
              })

              if (resp.data?.success) {
                refetchSubCategoryDetails()
              }
            } else {
              handleModalOpen('addProductPicksModal')
            }
          }}
          disabled={editingSubCategory}
          loading={editingSubCategory}
          primary
          className="max-w-fit"
          label={
            JSON.stringify(productPicks) !==
            JSON.stringify(singleSubCategoryDetails?.data?.ourPicks ?? [])
              ? 'Save'
              : 'Add Products'
          }
          size="medium"
        />
      </div>

      <ProductTileContainer
        products={productPicks}
        handleSortEnd={(products) => {
          setProductPicks(products)
        }}
        canDelete
        onDeleteProduct={(p, idx) => {
          setProductPicks(
            removeElementAtIndex(JSON.parse(JSON.stringify(productPicks)), idx),
          )
        }}
        sortable
        onViewProduct={(p) => {
          navigate(`/products/view/${p?._id}`)
        }}
      />

      <SelectProductModal
        open={modal === 'addProductPicksModal' && modalOpen}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        maxSelection={50}
        selectedProducts={productPicks}
        onSuccessCallback={(products) => {
          setProductPicks([
            ...productPicks,
            ...products.filter(
              (p) => !productPicks.map((i) => i._id).includes(p._id),
            ),
          ])

          handleModalClose()
        }}
        query={{
          subcategoryId: subCategoryId,
          categoryId: singleSubCategoryDetails?.data?.category?._id,
        }}
      />
    </>
  )
}
